export const LOADING = "LOADING";
export const LOADING_FREEZE = "LOADING_FREEZE";
export const REGISTRATION_SUCCESS = "REGISTRATION_SUCCESS";
export const REGISTRATION_COMPLETED = "REGISTRATION_COMPLETED";
export const REGISTRATION_RESET = "REGISTRATION_RESET";
